package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.css.px

object AppStylesGlobal : StyleSheet() {

    val appRoot by style {
        property("height", "100vh")
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        minHeight(0.px)                      // ✅ important pour flex/overflow
    }
    val global by style {
        property("font-family", AppStylesTokens.FONT_FAMILY)
        property(
            "background-image",
            "radial-gradient(760px 420px at 18% 10%, rgba(102,96,230,0.055) 0%, rgba(102,96,230,0.00) 62%), " +
                    "linear-gradient(180deg, rgba(249,250,253,1) 0%, rgba(243,246,251,1) 100%)"
        )
        property("background-attachment", "fixed")
        property("color", AppStylesTokens.BODY)

        // ✅ devient un flex-child qui prend le reste de l’écran sous le header
        property("flex", "1")
        minHeight(0.px)
        overflow("hidden") // ✅ oui, ici aussi on veut empêcher un 2e scroll (c’est la card qui scrolle)
    }
}